{
  "cards": {
    "continue": "Continuar",
    "start": "Empezar",
    "viewCourse": "Ver curso",
    "previous": "Anterior",
    "next": "Siguiente",
    "goToSlide": "Ir a la diapositiva {{number}}",
    "banner": "Banner",
    "percentComplete": "{{percent}}% completado",
    "percentCompleted": "{{percent}}% completado",
    "access": "Acceder",
    "previousBanner": "Banner anterior",
    "nextBanner": "Siguiente banner",
    "new": "Nuevo",
    "viewDetails": "Ver detalles",
    "review": "Repasar",
    "locked": "Bloqueado",
    "completed": "Completado",
    "complete": "Completo",
    "restrictedAccess": "Acceso restringido",
    "scrollLeft": "Desplazar a la izquierda",
    "scrollRight": "Desplazar a la derecha",
    "buy": "Comprar",
    "unlock": "Desbloquear acceso"
  },
  "courseSections": {
    "relatedCourses": "Cursos relacionados",
    "noCourseSelected": "Ningún curso seleccionado",
    "modules": "Módulos",
    "noModuleSelected": "Ningún módulo seleccionado",
    "dragToReorder": "Arrastra para reordenar",
    "progress": "Progreso",
    "viewTrail": "Ver ruta",
    "lessonCount_one": "{{count}} clase",
    "lessonCount_zero": "{{count}} clases",
    "lessonCount_other": "{{count}} clases"
  },
  "home": {
    "greeting": {
      "morning": "Buenos días, <name>{{name}}</name>",
      "afternoon": "Buenas tardes, <name>{{name}}</name>",
      "evening": "Buenas noches, <name>{{name}}</name>"
    },
    "defaultName": "Alumno",
    "loading": "Cargando...",
    "quickLinks": {
      "courses": {
        "title": "Mis cursos",
        "description": "Accede a todos tus cursos disponibles"
      },
      "ranking": {
        "title": "Ranking",
        "description": "Consulta tu posición y tus logros"
      },
      "community": {
        "title": "Comunidad",
        "description": "Conecta con otros alumnos"
      },
      "certificates": {
        "title": "Certificados",
        "description": "Descarga tus certificados de finalización"
      }
    },
    "subtitle": {
      "continue": "Continúa donde lo dejaste",
      "explore": "Explora tus cursos",
      "start": "Empieza tu viaje de aprendizaje"
    },
    "stats": {
      "courses": "cursos",
      "inProgress": "en curso",
      "completed": "completados"
    },
    "continueWatching": "Sigue viendo",
    "continueLesson": "Clase \"{{title}}\" · te quedaste en {{time}}",
    "quickAccess": "Acceso rápido",
    "continueLearning": "Sigue aprendiendo",
    "viewAll": "Ver todos"
  },
  "courses": {
    "loading": "Cargando cursos...",
    "title": "Cursos",
    "subtitle": "Explora todos los cursos disponibles en la plataforma",
    "courseCount_one": "{{count}} curso",
    "courseCount_zero": "{{count}} cursos",
    "courseCount_other": "{{count}} cursos",
    "startCourse": "Iniciar curso",
    "emptyTitle": "No se encontraron cursos",
    "emptyDescription": "¡Pronto tendremos novedades!"
  },
  "course": {
    "notFoundTitle": "Curso no encontrado",
    "notFoundDescription": "El curso que buscas no existe.",
    "backToCourses": "Volver a los cursos",
    "lockedTitle": "Contenido bloqueado",
    "lockedDescription": "Todavía no tienes acceso a este curso. Asegura tu plaza para desbloquear todas las clases.",
    "lockedNoCheckout": "Este curso todavía no está disponible para la compra. Habla con el productor para obtener acceso.",
    "buyNow": "Comprar ahora",
    "changePlanTitle": "Planes de este curso",
    "changePlanDescription": "¿Quieres cambiar de plan? Al suscribirte a otro plan, el actual finaliza y tu acceso continúa.",
    "choosePlan": "Elegir este plan",
    "fromPrice": "desde {{price}}"
  },
  "trail": {
    "startHere": "¡Empieza aquí!",
    "backToCourse": "Volver al curso",
    "title": "Ruta de aprendizaje",
    "modulesProgress_one": "<bold>{{completed}}</bold>/{{count}} módulo",
    "modulesProgress_zero": "<bold>{{completed}}</bold>/{{count}} módulos",
    "modulesProgress_other": "<bold>{{completed}}</bold>/{{count}} módulos",
    "start": "Inicio de la ruta",
    "completed": "¡Ruta completada!",
    "end": "Fin de la ruta",
    "emptyTitle": "No hay módulos disponibles",
    "emptyDescription": "Este curso aún no tiene módulos registrados."
  },
  "ranking": {
    "loading": "Cargando ranking...",
    "title": "Ranking",
    "subtitle": "Gana puntos, sube de nivel y destaca entre los mejores",
    "rankBadge": "#{{rank}} en el ranking",
    "howItWorks": "¿Cómo funciona?",
    "stats": {
      "totalXp": "XP total",
      "accumulatedPoints": "puntos acumulados",
      "level": "Nivel",
      "defaultLevel": "Principiante",
      "position": "Posición",
      "overallRanking": "en el ranking general",
      "streak": "Racha",
      "consecutiveDays": "días consecutivos"
    },
    "achievements": {
      "title": "Logros",
      "unlocked": "{{unlocked}} de {{total}} desbloqueados"
    },
    "leaderboard": {
      "title": "Clasificación",
      "subtitle": "Los mejores alumnos de la plataforma"
    },
    "periods": {
      "all": "General",
      "monthly": "Mensual",
      "weekly": "Semanal"
    },
    "anonymous": "Anónimo",
    "you": "Tú",
    "pagination": {
      "previous": "Anterior",
      "next": "Siguiente",
      "pageOf": "{{page}} de {{total}}"
    },
    "empty": {
      "title": "Ranking vacío",
      "description": "¡Completa clases para ganar puntos y aparecer aquí!"
    },
    "emptyPeriod": {
      "title": "Nadie ha puntuado en este período todavía",
      "description": "¡Completa clases para ganar puntos y aparecer aquí!"
    },
    "explanationTitle": "¿Cómo funciona la gamificación?",
    "howItWorksModal": {
      "xpPerAction": "XP por acción",
      "xpPerLevel": "XP por nivel",
      "learning": "Aprendizaje",
      "community": "Comunidad",
      "level": "Nivel",
      "fromXp": "Desde {{xp}}",
      "dailyLimit": "(hasta {{count}} por día)",
      "courseProgress": "Llegaste al {{percent}}% del curso"
    }
  },
  "achievements": {
    "title": "Logros",
    "subtitle": "Sigue tu progreso y desbloquea logros épicos",
    "stats": {
      "points": "Puntos",
      "defaultLevel": "Principiante",
      "streak": "Racha",
      "ranking": "Ranking"
    },
    "levelProgress": {
      "title": "Progreso de nivel",
      "level": "Nivel {{level}}: {{name}}",
      "pointsNeeded": "Faltan <highlight>{{points}}</highlight> puntos para el siguiente nivel"
    },
    "tabs": {
      "achievements": "Logros",
      "ranking": "Ranking"
    },
    "unlockedSummary": "<highlight>{{unlocked}}</highlight> de <mono>{{total}}</mono> logros desbloqueados",
    "leaderboard": {
      "title": "Top 10 - Ranking general",
      "defaultUser": "Usuario",
      "empty": "Todavía no hay usuarios en el ranking.",
      "yourPosition": "Tu posición"
    }
  },
  "community": {
    "title": "Comunidad",
    "subtitle": "Comunidad e interacción",
    "enterDescription": "Resuelve dudas, comparte lo que estás aprendiendo y conversa con los demás alumnos. Tu acceso se hace automáticamente con tu cuenta del área de miembros.",
    "enterButton": "Entrar a la comunidad",
    "entering": "Entrando...",
    "enterError": "No fue posible entrar a la comunidad. Inténtalo de nuevo.",
    "unavailable": "La comunidad todavía no está disponible."
  },
  "certificates": {
    "title": "Mis certificados",
    "subtitle": "Tus certificados de finalización de cursos",
    "completionCertificate": "Certificado de finalización",
    "issuedOn": "Emitido el {{date}}",
    "view": "Ver certificado",
    "download": "Descargar",
    "validate": "Validar certificado",
    "emptyTitle": "Todavía no tienes certificados",
    "emptyDescription": "Completa tus cursos para recibir certificados de finalización.",
    "viewMyCourses": "Ver mis cursos",
    "verificationTitle": "Verificación de autenticidad",
    "verificationDescription": "Todos los certificados tienen un código de verificación único. Cualquier persona puede comprobar la autenticidad de tu certificado a través de nuestra página de verificación.",
    "verifyLink": "Verificar un certificado →",
    "pendingTitle": "Cursos completados",
    "pendingDescription": "Completaste estos cursos. Genera tu certificado.",
    "generate": "Generar certificado",
    "generated": "¡Certificado generado!",
    "generateError": "No se pudo generar el certificado. Inténtalo de nuevo.",
    "notAvailableYet": "La escuela todavía no ha habilitado el certificado de este curso. Inténtalo más tarde."
  },
  "profile": {
    "toasts": {
      "nameRequired": "El nombre no puede estar vacío",
      "profileUpdated": "¡Perfil actualizado correctamente!",
      "profileUpdateError": "Error al actualizar el perfil",
      "unsupportedImageFormat": "Formato de imagen no compatible. Usa JPG, PNG, GIF o WebP.",
      "imageTooLarge": "La imagen debe pesar como máximo 5MB",
      "imageUrlMissing": "No se devolvió la URL de la imagen",
      "photoUpdated": "¡Foto actualizada correctamente!",
      "photoUpdateError": "Error al actualizar la foto. Inténtalo de nuevo."
    },
    "title": "Mi cuenta",
    "subtitle": "Gestiona la información y la configuración de tu perfil",
    "level": "Nivel",
    "avatar": {
      "save": "Guardar foto",
      "change": "Cambiar foto"
    },
    "personal": {
      "title": "Datos personales",
      "description": "Completa tus datos principales",
      "fullName": "Nombre completo *",
      "fullNamePlaceholder": "Tu nombre completo",
      "email": "Correo electrónico",
      "emailReadOnly": "El correo electrónico no se puede cambiar",
      "phone": "Celular/WhatsApp",
      "birthDate": "Fecha de nacimiento",
      "occupation": "Ocupación",
      "occupationPlaceholder": "Ej.: Desarrollador Full Stack",
      "bio": "Bio (opcional)",
      "bioPlaceholder": "Cuéntanos un poco sobre ti..."
    },
    "address": {
      "title": "Dirección",
      "zipCode": "Código postal",
      "zipCodePlaceholder": "00000",
      "state": "Estado/Provincia",
      "statePlaceholder": "Jalisco",
      "city": "Ciudad",
      "cityPlaceholder": "Guadalajara",
      "neighborhood": "Barrio",
      "street": "Calle, avenida...",
      "number": "Número",
      "complement": "Complemento",
      "complementPlaceholder": "Depto., piso..."
    },
    "social": {
      "title": "Redes sociales",
      "usernamePlaceholder": "@tuusuario"
    },
    "customFields": {
      "title": "Información adicional",
      "selectPlaceholder": "Selecciona"
    },
    "saving": "Guardando...",
    "saveChanges": "Guardar cambios"
  }
}
